import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import OperateTabs_4 from "examples/Tabs/OperateTabs_4";

function Operate_4() {
  return (
    <DashboardLayout>
      <OperateTabs_4 />
    </DashboardLayout>
  );
}

export default Operate_4;
